/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import Header from "../../../components/common/layout/Header";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useParams } from "react-router-dom";
import NoSearch from "../../../components/common/form/NoSearch";
import { Helmet } from "react-helmet";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";
import CorporateHeader from "../../../components/common/layout/CorporateHeader";
import Error from "../../../components/common/form/Error";

const Search = ({ type }: any) => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any>(null);
    const [isError, setIsError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const loaderData: any[] = [1, 2, 3, 4, 5];
    const { t } = useTranslation('common');
    const params = useParams();
    useSitemap();

    const getPageSearchData = async () => {
        try {
            setLoading(true);
            setIsError(false);
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + (type === "passenger" ? url?.search_api : url?.corporate_search_api)}?search=${params?.search}`);

            if (res && res?.status === 200) {
                setData(res?.data?.results);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setIsError(false);
            console.error("error while feching search data", error);
        }
    };

    useEffect(() => {
        (!!lang && !!params?.search) && getPageSearchData()
    }, [lang, params?.search])

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.search.title")}</title>
                <meta name="description" content={t("seo_friendly.search.desc")} />
            </Helmet>
            <div className='bg-white dark:bg-bgDarkDull'>
                {type === "passenger" ? <div className="w-full h-[240px] xlx:h-[285px] relative banner-bg">
                    <img src={theme === "dark" ? require("../../../assets/images/pages3.png") : require("../../../assets/images/pages.png")} alt="bg-image" className="w-full h-full object-cover" />
                    <div className="absolute top-0 left-0 right-0 bottom-0 items-start justify-between w-full flex flex-col pb-[25px] h-full">
                        <div className="w-full h-fit">
                            <Header type={type} />
                        </div>

                        <div className="flex container items-center justify-center md:!px-[30px] xlx:!px-[50px]">
                            <h2 className="text-primaryText dark:text-white font-bold">{t("passenger.search.search_result")}</h2>
                        </div>
                    </div>
                </div> :
                    <div className="w-full h-[240px] xlx:h-[315px] relative">
                        <div className="relative w-full h-full">
                            <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full" style={{ background: "linear-gradient(87deg, #162340 28%, rgba(22, 35, 64, 0.00) 94.38%)" }}></div>
                            <img src={require("../../../assets/images/pattern3.png")} alt="pattern" className="absolute top-0 left-0 bottom-0 z-[1] h-full" />
                            <img src={require("../../../assets/images/pages4.png")} alt="bg-image" className="w-full h-full object-cover" />
                        </div>
                        <div className="absolute top-0 left-0 right-0 bottom-0 items-start justify-between w-full flex flex-col pb-[58px] sm:pb-[45px] mms:pb-[40px] lgs:pb-[35px] xlx:pb-[60px] h-full z-[2]">
                            <div className="w-full h-fit">
                                <CorporateHeader bg={true} blur={true} />
                            </div>

                            <div className="flex container items-center justify-center mms:!px-[30px]">
                                <h2 className="text-white font-bold">{t("passenger.search.search_result")}</h2>
                            </div>
                        </div>
                    </div>
                }
                <div className={`container ${type === "passenger" ? "py-[40px] xlx:py-[60px]" : "pt-[30px] xsm:pt-[40px] xlx:pt-[60px] pb-[60px] xsm:pb-[70px] lg:pb-[90px] xlx:pb-[110px]"}`} id="home">
                    {loading ?
                        <div className="w-full border border-gray-200 dark:border-gray-700 animate-pulse">
                            {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                <div className={`${(index + 1 === loaderData?.length) ? "" : "border-b dark:border-[#454545] border-[#E7E8EC]"} w-full gap-[15px] flex items-center justify-between px-[25px] xlx:px-[35px] py-[12px] xlx:py-[15px]`} key={index}>
                                    <div className="max-w-[150px] w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    <div className="w-[20px] h-[12px] bg-gray-200 rounded-sm dark:bg-gray-700"></div>
                                </div>
                            ))}
                        </div>
                        :
                        <>
                            {isError ? <Error /> : <>
                                {(data?.length > 0 && !!data) ? <div className="accordion !w-full">
                                    {Array.isArray(data) && data?.map((item: any, index: number) => (
                                        <div key={index} className="accordion-item">
                                            <input className="toggle" id={`${item?.title}${index}`} type="checkbox" />
                                            <label className="accordion-item-header" htmlFor={`${item?.title}${index}`}>{item?.title}</label>
                                            <div className="accordion-item-body">
                                                <div className="accordion-item-body-content content-page" dangerouslySetInnerHTML={{ __html: item?.content }} />
                                            </div>
                                        </div>
                                    ))}
                                </div> :
                                    <NoSearch btn="hide" />
                                }
                            </>}
                        </>}
                </div>
            </div>
        </>
    );
};

export default Search;